module.exports = __webpack_public_path__ + "img/img_inner_pinkcheck.4c03e2e0.png";